import { cn } from '@/lib/utils';

interface UserAvatarProps {
  picture?: string;
  name?: string;
  className?: string;
}

export function UserAvatar({ picture, name, className }: UserAvatarProps) {
  if (picture) {
    return (
      <img
        src={picture}
        alt=""
        className={cn('rounded-full object-cover', className)}
        referrerPolicy="no-referrer"
      />
    );
  }

  const initial = name?.trim().charAt(0).toUpperCase();

  return (
    <span
      className={cn(
        'flex items-center justify-center rounded-full bg-muted text-xs font-medium text-muted-foreground',
        className
      )}
      aria-hidden="true"
    >
      {initial ?? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      )}
    </span>
  );
}
